import React from "react";
import Select from "react-select";

import {
  allDurationKindSeletors,
  DurationKindSelectorInterface,
} from "./DurationKind";

import "./DurationKindSelector.css";

export function DurationKindSelector(
  selectedDurationKindSelector: DurationKindSelectorInterface,
  setSelectedDurationKind: (state: DurationKindSelectorInterface) => void
): JSX.Element {
  return (
    <div className="duration-kind-selector">
      <Select
        defaultValue={selectedDurationKindSelector}
        onChange={(selectedOption) => {
          if (selectedOption) {
            setSelectedDurationKind(selectedOption);
          }
        }}
        options={allDurationKindSeletors}
        // styles={colourStyles}
      />
    </div>
  );
}
